export function freezeMap(map) {
    for (const k in map) {
        Object.freeze(map[k]);
    }
    return Object.freeze(map);
}
